// Rough ZIP prefix (first digit) → US state groupings. Not precise, but
// enough for the "deals near me" prioritisation UX.
// See https://en.wikipedia.org/wiki/ZIP_Code#Primary_state_prefixes
export const ZIP_PREFIX_STATES = {
  "0": ["MA", "RI", "NH", "ME", "VT", "CT", "NJ", "PR", "VI"],
  "1": ["DE", "NY", "PA"],
  "2": ["DC", "MD", "NC", "SC", "VA", "WV"],
  "3": ["AL", "FL", "GA", "MS", "TN"],
  "4": ["IN", "KY", "MI", "OH"],
  "5": ["IA", "MN", "MT", "ND", "SD", "WI"],
  "6": ["IL", "KS", "MO", "NE"],
  "7": ["AR", "LA", "OK", "TX"],
  "8": ["AZ", "CO", "ID", "NM", "NV", "UT", "WY"],
  "9": ["AK", "CA", "HI", "OR", "WA"],
};

// Regional grocery / retail store → US state list where they operate.
// Only stores with a meaningfully regional footprint are listed. Everything
// else defaults to "nationwide" and is always included.
export const REGIONAL_STORES = {
  "H-E-B": ["TX"],
  "Central Market": ["TX"],
  "Buc-ee's": ["TX", "AL", "FL", "GA", "KY", "SC", "TN"],
  Publix: ["FL", "GA", "AL", "SC", "TN", "NC", "VA"],
  Wegmans: ["NY", "NJ", "PA", "MA", "MD", "VA", "NC", "DE"],
  "Winn-Dixie": ["FL", "AL", "GA", "LA", "MS"],
  "Piggly Wiggly": ["AL", "GA", "SC", "NC", "TN", "WI"],
  "Harris Teeter": ["NC", "SC", "VA", "MD", "DE", "DC", "FL", "GA"],
  "Ingles Markets": ["NC", "SC", "GA", "TN", "AL", "VA"],
  "Rouses Markets": ["LA", "MS", "AL"],
  "Weis Markets": ["PA", "NY", "NJ", "MD", "VA", "WV", "DE"],
  "Fresco y Más": ["FL"],
  "Harveys Supermarkets": ["FL", "GA"],
  "Stop & Shop": ["MA", "CT", "NY", "NJ", "RI"],
  ShopRite: ["NJ", "NY", "PA", "CT", "DE", "MD"],
  "Giant Food": ["MD", "VA", "DC", "DE"],
  "Giant Eagle": ["OH", "PA", "WV", "MD", "IN"],
  "Price Chopper": ["NY", "PA", "VT", "CT", "MA", "NH"],
  "Market Basket": ["MA", "NH", "ME"],
  "Big Y": ["MA", "CT"],
  Hannaford: ["ME", "NH", "VT", "MA", "NY"],
  "Shaw's": ["ME", "NH", "VT", "MA", "RI"],
  "Star Market": ["MA"],
  "Tops Friendly Markets": ["NY", "PA", "VT"],
  "Redner's Markets": ["PA", "MD", "DE"],
  "Hy-Vee": ["IA", "IL", "KS", "MN", "MO", "NE", "SD", "WI"],
  "Cub Foods": ["MN", "IL"],
  "Jewel-Osco": ["IL", "IN", "IA"],
  "Mariano's": ["IL"],
  Schnucks: ["MO", "IL", "IN", "WI"],
  Dierbergs: ["MO"],
  Fareway: ["IA", "MN", "IL", "SD", "NE"],
  "Festival Foods": ["WI"],
  "Metro Market": ["WI"],
  "Pick 'n Save": ["WI"],
  Dillons: ["KS"],
  Bakers: ["NE"],
  "Owen's": ["IN"],
  "Ruler Foods": ["IN", "IL", "KY", "TN", "MO", "OH"],
  Randalls: ["TX"],
  "Tom Thumb": ["TX"],
  "United Supermarkets": ["TX"],
  "Market Street": ["TX", "NM"],
  "Brookshire Brothers": ["TX", "LA"],
  "Brookshire's": ["TX", "LA", "AR"],
  "Fiesta Mart": ["TX"],
  "El Rio Grande Latin Market": ["TX"],
  Foodarama: ["TX"],
  Vons: ["CA", "NV"],
  Ralphs: ["CA"],
  Pavilions: ["CA"],
  "Fry's Food Stores": ["AZ"],
  "Smith's Food & Drug": ["UT", "NV", "ID", "AZ", "NM", "MT", "WY"],
  "King Soopers": ["CO"],
  "City Market": ["CO", "UT", "WY", "NM"],
  QFC: ["WA", "OR"],
  "Bashas'": ["AZ"],
  "Stater Bros. Markets": ["CA"],
  "WinCo Foods": ["AZ", "CA", "ID", "MT", "NV", "OK", "OR", "TX", "UT", "WA"],
  "Nugget Markets": ["CA"],
  "PCC Community Markets": ["WA"],
  "New Seasons Market": ["OR", "WA"],
  "Fred Meyer": ["OR", "WA", "ID", "AK"],
  Meijer: ["IL", "IN", "KY", "MI", "OH", "WI"],
  Wawa: ["PA", "NJ", "DE", "MD", "VA", "FL", "DC"],
  Sheetz: ["PA", "MD", "VA", "WV", "OH", "NC"],
  "Casey's": ["IA", "IL", "IN", "KS", "MN", "MO", "NE", "OH", "OK", "SD", "TN", "TX", "WI"],
  Speedway: ["OH", "IN", "MI", "PA", "IL", "KY", "TN", "FL"],
  GetGo: ["OH", "PA", "WV", "MD"],
  "Kum & Go": ["IA", "AR", "CO", "MN", "MO", "MT", "NE", "ND", "OK", "SD", "WY"],
  RaceTrac: ["FL", "GA", "SC", "NC", "TN", "AL", "MS", "LA", "TX", "OK", "KY", "AR"],
  QuikTrip: ["OK", "TX", "AZ", "CO", "GA", "KS", "MO", "NC", "NE", "SC", "VA"],
  "Cumberland Farms": ["CT", "MA", "ME", "NH", "NY", "RI", "VT", "FL"],
  "Love's Travel Stops": ["AR", "AZ", "CA", "CO", "FL", "GA", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "MI", "MN", "MO", "MS", "NC", "NE", "NM", "NV", "OH", "OK", "OR", "PA", "SC", "TN", "TX", "UT", "VA", "WA", "WI", "WV", "WY"],
  Stripes: ["TX", "NM", "OK"],
  "Stewart's Shops": ["NY", "VT"],
  "Kwik Trip": ["WI", "MN", "IA", "IL"],
  Maverik: ["UT", "ID", "WY", "MT", "AZ", "CO", "NV", "OR", "NE", "WA", "NM"],
  "Rutter's": ["PA"],
  "Royal Farms": ["MD", "DE", "VA", "PA", "NJ"],
  "Turkey Hill": ["PA"],
  "Whataburger": ["AL", "AZ", "AR", "FL", "GA", "LA", "MS", "NM", "OK", "TN", "TX"],
  "In-N-Out Burger": ["CA", "NV", "OR", "AZ", "UT", "TX", "CO", "ID"],
  "Raising Cane's": ["AL", "AZ", "AR", "CA", "CO", "FL", "GA", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "MI", "MS", "MO", "NE", "NV", "NM", "NY", "NC", "OH", "OK", "OR", "PA", "SC", "TN", "TX", "UT", "VA", "WA", "WV", "WI"],
  "Sonic": [], // treated as nationwide
  "Culver's": [], // treated as nationwide
  "Bojangles": ["AL", "FL", "GA", "KY", "MD", "MS", "NC", "OH", "PA", "SC", "TN", "VA", "WV"],
  Wawa: ["PA", "NJ", "DE", "MD", "VA", "FL", "DC"],
};

export function stateFromZip(zip) {
  if (!zip || zip.length < 1) return null;
  return zip[0];
}

// Returns true if this store operates in the state group derived from a ZIP.
export function storeAvailableInZip(storeName, zip) {
  if (!zip) return true;
  const prefix = zip[0];
  const states = ZIP_PREFIX_STATES[prefix] || [];
  const regions = REGIONAL_STORES[storeName];
  if (!regions || regions.length === 0) return true; // nationwide
  return regions.some((s) => states.includes(s));
}
